import { apiGet, apiGetFeatureService, getMerchantId } from '../utils/api'

export function isFeatureFlagEnable(toggleName) {
  const merchantId = getMerchantId()
  return apiGetFeatureService(`merchants/${merchantId}/features/${toggleName}`).then(
    (res) => res.enabled,
  )
}
export function monolithIsFeatureFlagEnable(toggleName) {
  return apiGet(`unleash/enable/${toggleName}`).then((res) => res)
}



// WEBPACK FOOTER //
// ./src/api/unleash.js